/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/Pile',['lodash', 'absolute/debug', 'BigInteger', 'SolitaireShared/CardLogic/Supply', 'SolitaireShared/CardLogic/Card'],
    function (_, Debug, BigInteger, Supply, Card) {
        var Pile = function (supply, name, type) {
            this.initPile(supply, name, type);
        };

        Pile.prototype.initPile = function (supply, name, type) {
            this.PileID = 0;
            this.Supply = supply;
            this.Name = name;
            this.Type = type;
            this.Cards = [];
        };

        Pile.prototype.GetCards = function () {
            return this.Cards;
        };

        Pile.prototype.ClearCards = function () {
            return this.Cards = [];
        };

        Pile.prototype.GetCardAtPos = function (i) {
            return this.Cards[i];
        };

        Pile.prototype.Count = function () {
            return this.Cards.length;
        };

        Object.defineProperty(Pile.prototype, "Count", {
            get: function () {
                return this.Cards.length;
            }
        });

        Object.defineProperty(Pile.prototype, "length", {
            get: function () {
                throw "Pile.length called - replace with .Count";
            }
        });

        Pile.prototype.Clear = function () {
            this.Cards = [];
        };

        Pile.prototype.ForceAdd = function (card) {
            var ok = true;

            if (card.Pile != null) {
                ok = card.Pile.ForceRemove(card);
            }

            if (ok) {
                this.Cards.push(card);
                card.Pile = this;
            }

            return ok;
        };

        Pile.prototype.ForceRemove = function (card) {
            var index = this.Cards.indexOf(card);
            if (index != -1) {
                this.Cards.splice(index, 1);
                return true;
            }
            return false;
        };

        Pile.prototype.AddNew = function (card) {
            if (card.Pile != null) {
                card.Pile.ForceRemove(card);
            }
            this.Cards.push(card);
            card.Pile = this;
        };

        Pile.prototype.Sort = function () {
            this.Cards.sort(function (a, b) {
                return a.CompareTo(b);
            });
        };

        Object.defineProperty(Pile.prototype, "Top", {
            get: function () {
                if (this.Cards.length == 0) {
                    return null;
                }
                return this.Cards[this.Cards.length - 1];
            }
        });

        Object.defineProperty(Pile.prototype, "Bottom", {
            get: function () {
                if (this.Cards.length == 0) {
                    return null;
                }
                return this.Cards[0];
            }
        });

        Pile.prototype.moveCardInPile = function(from, to) {
            var tmpCard = this.Cards[from];
            this.Cards.splice(from,1);
            this.Cards.splice(to, 0, tmpCard);
        };

        Pile.prototype.NthFromTop = function (N) {
            if (this.Cards.length < N) return null;
            else if (N <= 0) return null;
            else return this.Cards[this.Cards.length - N];
        };

        Object.defineProperty(Pile.prototype, "Empty", {
            get: function () {
                return this.Cards.length == 0;
            }
        });

        /// <summary>
        /// Shuffle with the given deck seed given as a BigInt. Returns a string corresponding to the actual deck seed used.
        /// </summary>
        /// <param name="deckSeed">The deck seed that directly controls the shuffle.</param>
        Pile.prototype.Shuffle = function (deckSeed) {
            if (!deckSeed) {
                if (this.Supply.Options.DIFFICULTY && this.Supply.Options.DIFFICULTY !== "RANDOM")
                    deckSeed = this.Supply.GetBakedInDeckSeed();
                else
                    deckSeed = this.Supply.GetRandomDeckSeed();
            }

            if (typeof deckSeed == 'string') {
                var deckSeedString = deckSeed;
                deckSeed = new BigInteger(deckSeedString);
            }

            this.Sort();

            var keys = this.GetKeysFromSeed(deckSeed);
            var seed = this.GetSeedFromKeys(keys);

            var deckSeedToReturn = seed.toString();

            Debug.log("seed = " + deckSeedToReturn);

            // Fisher-Yates from http://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_modern_algorithm
            for (var i = this.Cards.length - 1; i >= 1; i--)
            {
                if (i != keys[i])
                {
                    var tmp = this.Cards[i];
                    this.Cards[i] = this.Cards[keys[i]];
                    this.Cards[keys[i]] = tmp;
                }
            }

            return deckSeedToReturn;
        };


        Pile.prototype.GetCardPosFromEnd = function (card) {
            for (var i = this.Cards.length - 1; i >= 0; i--) {
                if (this.Cards[i] == card) {
                    return this.Cards.length - i;
                }
            }
            return 0;
        };

        Pile.prototype.ForceRemoveTop = function (num) {
            if (num == 0) return null;

            var start = this.Cards.length - num;
            if (start < 0) {
                start = 0;
                num = this.Cards.length;
            }
            var ret = this.Cards.splice(start, num);

            _.forEach(ret, function (card) {
                card.Pile = null;
            });

            return ret;
        };

        Pile.prototype.ForceAddTop = function (newCards) {
            _.forEach(newCards, function (card) {
                card.Pile = this;
            },
            this);
            this.Cards = this.Cards.concat(newCards);
        };

        Pile.prototype.ToString = function () {
            var output = "";
            output += PileID < 10 ? "0" + PileID : PileID;
            if (this.Name != null)
                output += this.Name;

            output += "(" + this.Cards.length + ")";

            _.forEach (this.Cards, function (card) {
                if (card != this.Cards[0]) output += (" ");
                output += card.ToString();
            },
            this);

            return output;
        };




        Pile.prototype.GetKeysFromSeed = function (seed) {
            var retval = [];

            function factorial(n) {
                var result = new BigInteger(1);
                var i = 0;
                while (++i <= n) {
                    result = result.multiply(new BigInteger(String(i)));
                }
                return result;
            }


            var key = new BigInteger("0");
            var tmp = new BigInteger(this.Cards.length);

            var fact = new BigInteger(this.Cards.length);
            fact = factorial(fact.value[0], 65536);

            seed = seed.mod(fact);

            for (var i = this.Cards.length; i > 0; i--) {
                key = seed.mod(tmp);
                retval[i-1] = key.toJSNumber();
                seed = seed.divide(tmp);
                tmp = tmp.subtract(1);
            }
            return retval;
        };

        /*

         public uint[] GetKeysFromSeed(BigInt seed)
         {
         uint[] retval = new uint[Cards.Count];
         Toolbox.BigInt key = new Toolbox.BigInt("0");
         Toolbox.BigInt tmp = new Toolbox.BigInt(Cards.Count.ToString(), seed.Precision);

         BigInt fact = new BigInt(Cards.Count,seed.Precision);
         fact.Factorial();
         seed = seed % fact;
         for (int i = Cards.Count; i > 0; i--)
         {
         key = (seed % tmp);
         retval[i-1] = key.GetInteger();
         seed /= tmp;
         tmp.Decrement();
         }
         return retval;
         }
         */


        Pile.prototype.GetSeedFromKeys = function (keys, numCards) {
            if (!numCards) {
                numCards = this.Cards.length;
            }

            var retval = new BigInteger("0");

            for (var i = 1; i < numCards; i++)
            {
                retval = retval.multiply(new BigInteger((i + 1).toString()));
                retval = retval.add(new BigInteger(keys[i]));
            }

            return retval;
        };

        /*
         public static BigInt GetSeedFromKeys(uint[] keys, int numCards)
         {
         BigInt retval = new BigInt("0",(BigInt.PrecisionSpec)512);

         for (int i = 1; i < numCards; i++)
         {
         retval *= new Toolbox.BigInt((i + 1).ToString());
         retval += new Toolbox.BigInt(keys[i],(BigInt.PrecisionSpec)512);
         }

         return retval;
         }
         */

        Pile.prototype.IsPileAllowToRevealCard = function () {
            return this.Name != "Stock" && this.Name != "Waste" && this.Type != "Foundation";
        };

        Pile.ConstructSeedFromDeck = function(deck, numCards) {
            var keys = [];
            var cardLocations =[];
            var arrangement =[];
            // Each card begins in its location in order
            for (var i = 0; i < numCards; i++)
            {
                cardLocations[i] = i;
                keys[i] = i;
                arrangement[i] = i;
            }

            // Arrangement: Card in ith position
            // CardLocation: Where is card i?
            // Keys: What order of swaps will build this deck?
            for (var i = numCards - 1; i >= 0; i--)
            {
                if (arrangement[i] != deck[i])
                {
                    var card_i = arrangement[i];
                    var card_i_location = cardLocations[card_i];
                    var card_swapped = arrangement[cardLocations[deck[i]]];
                    var card_swapped_location = cardLocations[card_swapped];

                    arrangement[i] = card_swapped;
                    arrangement[cardLocations[deck[i]]] = card_i;

                    keys[i] = card_swapped_location;

                    cardLocations[card_i] = card_swapped_location;
                    cardLocations[card_swapped] = card_i_location;
                    /*uint iDest = cardLocations[deck[i]];
                     uint otherDest = cardLocations[i];

                     keys[cardLocations[i]] = cardLocations[deck[i]];

                     cardLocations[i] = iDest;
                     cardLocations[deck[i]] = otherDest;*/
                }
            }

            return this.GetSeedFromKeys(keys, numCards);
        };


        return Pile;
    });
